import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSun } from '@fortawesome/free-solid-svg-icons'
import './Button.css'

export default function Button({ text, isLoading, onClick, className = '', disabled = false, type }) {
  return (
    <button className={`btn ${className}`} onClick={onClick} disabled={disabled} type={type}>
      {isLoading ? <FontAwesomeIcon icon={faSun} spin /> : text}
    </button>
  )
}

